import { useTranslation } from "react-i18next";
import "../../../i18n";
import SectionLabel from "../components/SectionLabel";
import BrowserFrame from "../components/BrowserFrame";

const BULLET_KEYS = ["b1", "b2", "b3", "b4", "b5"];

const BARS = [
  { label: "0–40", height: 35, hi: false },
  { label: "41–55", height: 50, hi: false },
  { label: "56–70", height: 100, hi: true },
  { label: "71–85", height: 82, hi: true },
  { label: "86–100", height: 28, hi: false },
];

const STUDENT_ROWS = [
  { nameKey: "student1", initialKey: "initial1", color: "#8B5CF6", score: 92 },
  { nameKey: "student2", initialKey: "initial2", color: "#3B82F6", score: 78 },
  { nameKey: "student3", initialKey: "initial3", color: "#F97316", score: 64 },
];

function DashboardSection() {
  const { t } = useTranslation("marketing");

  return (
    <section className="ul-section" style={{ background: "#F8FAFC" }} id="dashboard">
      <div className="ul-feature-split reverse">
        <div className="ul-feature-content">
          <SectionLabel>{t("dashboard.label")}</SectionLabel>
          <h2 className="ul-section-title">{t("dashboard.titleLine1")}<br />{t("dashboard.titleLine2")}</h2>
          <p className="ul-section-sub">
            {t("dashboard.sub")}
          </p>
          <ul className="ul-feature-points">
            {BULLET_KEYS.map((b) => (
              <li key={b}>
                <span className="ul-check-icon" aria-hidden="true">✓</span>
                {t(`dashboard.bullets.${b}`)}
              </li>
            ))}
          </ul>
        </div>
        <div className="ul-feature-visual">
          <div className="ul-card-shell">
            <BrowserFrame domain="app.markszen.com" path="/dashboard/history-cl10/test-4">
              <div className="ul-card-body">
                <div className="ul-dash-header">
                  <div className="ul-dash-title">
                    {t("dashboard.mock.title")} <span className="ul-live-badge">{t("dashboard.mock.live")}</span>
                  </div>
                </div>
                <div className="ul-dash-stats">
                  <div className="ul-dash-stat-box">
                    <div className="ul-dash-stat-num">38</div>
                    <div className="ul-dash-stat-label">{t("dashboard.mock.studentsEvaluated")}</div>
                  </div>
                  <div className="ul-dash-stat-box">
                    <div className="ul-dash-stat-num orange">74%</div>
                    <div className="ul-dash-stat-label">{t("dashboard.mock.avgScore")}</div>
                  </div>
                  <div className="ul-dash-stat-box">
                    <div className="ul-dash-stat-num green">+6%</div>
                    <div className="ul-dash-stat-label">{t("dashboard.mock.vsLastTest")}</div>
                  </div>
                </div>
                <div className="ul-bar-chart">
                  {BARS.map((b) => (
                    <div className="ul-bar-col" key={b.label}>
                      <div className={`ul-bar${b.hi ? " hi" : ""}`} style={{ height: `${b.height}%` }} />
                      <div className="ul-bar-label">{b.label}</div>
                    </div>
                  ))}
                </div>
                <div className="ul-dash-footer">
                  <span className="ul-dash-footer-text">{t("dashboard.mock.vsLastTest")}</span>
                  <span className="ul-improving">{t("dashboard.mock.improving")}</span>
                </div>
                <div className="ul-student-list">
                  {STUDENT_ROWS.map((s) => (
                    <div className="ul-student-row" key={s.nameKey}>
                      <div className="ul-student-avatar" style={{ background: s.color }}>{t(`dashboard.mock.${s.initialKey}`)}</div>
                      <div className="ul-student-name">{t(`dashboard.mock.${s.nameKey}`)}</div>
                      <div className="ul-score-bar-wrap">
                        <div className="ul-score-bar" style={{ width: `${s.score}%` }} />
                      </div>
                      <div className="ul-student-score">{s.score}%</div>
                    </div>
                  ))}
                </div>
              </div>
            </BrowserFrame>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DashboardSection;
